/* global TradeInValuations */

import React, { Component } from "react"
import PropTypes from "prop-types"

import * as deepmerge from "deepmerge"

import TestDriveForm from "./TestDriveForm"
import TestDriveFormSummary from "./TestDriveFormSummary"
import TestDriveLeadForm from "./TestDriveLeadForm"
import CarAssemblage from "../CarAssemblage"
import VinLpnNumberInput from "./VinLpnNumberInput"
import { getParentIdFromUrl } from "../../../Helpers/Utility"
import EmailVerificationStep from "../EmailVerificationStep"
import { CountryProvider } from "component_library/contexts/countryContext"
import { clickTrackingDataPayload } from "../Utility/clickTrackingData"

class TestDriveBookingFlow extends Component {
  static propTypes = {
    formUrl: PropTypes.string,
    departmentOptions: PropTypes.array,
    initialPayload: PropTypes.object,
    replacementCarSummary: PropTypes.object,
    replacementCar: PropTypes.object,
    intendedCarChangePeriods: PropTypes.array,
    tradeInProps: PropTypes.object,
    trackFunction: PropTypes.func,
    testDriveFormOptionalValues: PropTypes.array,
    testDriveFlowTranslations: PropTypes.object,
    leadFormTranslations: PropTypes.object,
    enableDescriptionOfTheCar: PropTypes.bool,
    enableOwnValuation: PropTypes.bool,
    extraFields: PropTypes.object,
    customFields: PropTypes.array,
    interestedInModelList: PropTypes.array,
    country: PropTypes.string,
    vinLpnPattern: PropTypes.string,
    submitVinLpnUrl: PropTypes.string,
    consents: PropTypes.array,
    consentLabel: PropTypes.string,
    displayConsentTermsAboveCta: PropTypes.bool,
    getFullName: PropTypes.bool,
    validationTranslations: PropTypes.object,
    maxTradeInValue: PropTypes.number,
    datePickerProps: PropTypes.object,
    replacementCarSearch: PropTypes.object,
    accentColor: PropTypes.string,
    configKey: PropTypes.string,
    configParam: PropTypes.string,
    departmentParamName: PropTypes.string,
    emailVerificationRequired: PropTypes.bool,
    emailVerificationTexts: PropTypes.object,
    initialCurrentStep: PropTypes.string,
    tradeInValuation: PropTypes.object,
    leadFormUrl: PropTypes.string,
    bookingTime: PropTypes.string,
    creationToken: PropTypes.string,
    requireLpn: PropTypes.bool,
    disableTradeInFormInTestDriveFlow: PropTypes.bool,
    customerId: PropTypes.string,
  }

  state = {
    currentStep: this.props.initialCurrentStep || "book_test_drive",
    askForPostcode: Object.keys(this.props.extraFields).includes("postcode"),
    replacementCar: this.props.replacementCar,
    replacementCarSearch: this.props.replacementCarSearch,
    showReplacementCarSearch: false,
    configKey: this.props.configKey,
    tradeInValuation: this.props.tradeInValuation,
    leadFormUrl: this.props.leadFormUrl,
    bookingTime: this.props.bookingTime,
    creationToken: this.props.creationToken,
    department: this.props.departmentOptions?.filter((d) => d.current)[0]
      ?.value,
  }

  componentDidMount() {
    XdMessaging.sendMessage(window.parent, {
      action: "TestDriveBooking.bookTestDriveStarted",
      intendedReceiver: getParentIdFromUrl(location.href),
    })
  }

  componentDidUpdate() {
    TradeInValuations.viewChanged()
  }

  updateFlowOptions = (options) => {
    this.setState((prevState) => ({
      tradeInFlowSelectorOptions: {
        ...prevState.tradeInFlowSelectorOptions,
        ...options,
      },
    }))
  }

  bookTestDriveDone = (payload) => {
    let headers = new Headers({
      "Content-Type": "application/json",
    })

    // Merge payload objects with initial payload, making sure they don't override each other
    payload = deepmerge.all([
      this.props.initialPayload,
      payload,
      clickTrackingDataPayload(this.props.customerId),
    ])

    // If payload from the form contains information about configParam, do not overwrite it!
    if (!payload[this.props.configParam])
      payload[this.props.configParam] = this.props.configKey

    fetch(this.props.formUrl, {
      method: "POST",
      body: JSON.stringify(payload),
      headers,
    })
      .then((res) => {
        return res.json()
      })
      .then((data) => {
        console.log(data)
        this.setState({
          currentStep: this.props.emailVerificationRequired
            ? "verify_email"
            : "submit_numberplate",
          testDriveFormData: payload,
          leadFormUrl: data.updateUrl,
          creationToken: data.creationToken,
          bookingTime: data.bookingTime,
          buyerEmail: data.buyerEmail,
          configKey: payload[this.props.configParam],
          departmentKey: payload[this.props.departmentParamName],
          tradeInValuation: payload.trade_in_valuation,
        })
      })
    if (this.props.trackFunction)
      this.props.trackFunction("submitted the test drive booking")
    XdMessaging.sendMessage(window.parent, {
      action: "TestDriveBooking.bookTestDriveDone",
      testDriveFormData: JSON.stringify(payload),
      bookingTime: this.state.bookingTime,
      intendedReceiver: getParentIdFromUrl(location.href),
    })
  }

  vinLpnNumberSubmitted = (payload) => {
    // Merge payload objects with initial payload, making sure they don't override each other
    payload = deepmerge.all([this.props.initialPayload, payload])
    const vinLpn = encodeURIComponent(payload.vin_lpn)

    fetch(
      `${this.props.submitVinLpnUrl}?vin_lpn=${vinLpn}&${this.props.configParam}=${this.props.configKey}&get_km_placeholder=1`,
      {
        method: "GET",
      }
    )
      .then((res) => {
        return res.json()
      })
      .then((data) => {
        console.log(data)
        this.setState({
          currentStep: "car_assemblage",
          car: data.car,
          kmPlaceholder: data.kmPlaceholder,
          vinLpn: vinLpn,
        })
      })
    if (this.props.trackFunction)
      this.props.trackFunction("submitted the test drive vin_lpn number")
  }

  carAssemblageDone = (payload) => {
    // Merge payload objects with initial payload, making sure they don't override each other
    this.setState({ carAssemblageData: payload, currentStep: "lead_form" })
    if (this.props.trackFunction)
      this.props.trackFunction("submitted the test drive car details")
  }

  handleSelectedCarChange = (selectedCar) => {
    this.setState((prevState) => ({
      replacementCarSearch: {
        ...prevState.replacementCarSearch,
        preselectedCarInfo: selectedCar,
      },
      replacementCar: selectedCar,
      showReplacementCarSearch: false,
      department: selectedCar.department_id,
    }))
  }

  handleSelectedCarEdit = () => {
    this.setState({ showReplacementCarSearch: true })
  }

  render() {
    return (
      <CountryProvider value={this.props.country}>
        <React.Fragment>
          {this.state.currentStep === "book_test_drive" && (
            <TestDriveForm
              departmentOptions={this.props.departmentOptions}
              currentDepartment={this.state.department}
              intendedCarChangePeriods={this.props.intendedCarChangePeriods}
              trackFunction={this.props.trackFunction}
              finishedCallback={this.bookTestDriveDone}
              optionalValues={this.props.testDriveFormOptionalValues}
              translations={this.props.testDriveFlowTranslations}
              consents={this.props.consents}
              consentLabel={this.props.consentLabel}
              displayConsentTermsAboveCta={
                this.props.displayConsentTermsAboveCta
              }
              getFullName={this.props.getFullName}
              validationTranslations={this.props.validationTranslations}
              askForPostcode={this.state.askForPostcode}
              datePickerProps={this.props.datePickerProps}
              // Replacement car props
              replacementCarSummary={this.props.replacementCarSummary}
              replacementCar={this.state.replacementCar}
              handleSelectedCarChange={this.handleSelectedCarChange}
              handleSelectedCarEdit={this.handleSelectedCarEdit}
              replacementCarSearch={this.state.replacementCarSearch}
              showReplacementCarSearch={this.state.showReplacementCarSearch}
              accentColor={this.props.accentColor}
              emailVerificationRequired={this.props.emailVerificationRequired}
              departmentParamName={this.props.departmentParamName}
            />
          )}
          {this.state.currentStep === "verify_email" && (
            <React.Fragment>
              <EmailVerificationStep
                emailVerificationTexts={this.props.emailVerificationTexts}
                buyerEmail={this.state.tradeInValuation.buyer_email}
                isTestDriveFlow
              />
            </React.Fragment>
          )}
          {this.state.currentStep === "submit_numberplate" && (
            <React.Fragment>
              <TestDriveFormSummary
                tradeInValuation={this.state.tradeInValuation}
                department={this.props.departmentOptions?.filter(
                  (d) => d.value === this.state.departmentKey
                )}
                replacementCar={this.props.replacementCar}
                translations={this.props.testDriveFlowTranslations.completed}
                bookingTime={this.state.bookingTime}
                showHeadline
              />
              {!this.props.disableTradeInFormInTestDriveFlow && (
                <VinLpnNumberInput
                  country={this.props.country}
                  pattern={this.props.vinLpnPattern}
                  finishedCallback={this.vinLpnNumberSubmitted}
                  translations={this.props.testDriveFlowTranslations.completed}
                  requireLpn={this.props.requireLpn}
                />
              )}
            </React.Fragment>
          )}
          {this.state.currentStep === "car_assemblage" && (
            <React.Fragment>
              <h1>{this.props.leadFormTranslations.headline}</h1>
              <CarAssemblage
                {...this.props.tradeInProps}
                finishedCallback={this.carAssemblageDone}
                initialAssembledCar={this.state.car}
                trackFunction={this.props.trackFunction}
                departmentOptions={this.props.departmentOptions}
                scrollStepsIntoView={this.props.tradeInProps.fromModal}
                kmPlaceholder={this.state.kmPlaceholder}
                onCapturePostCode={this.handlePostCodeCaptured}
                onCaptureBuyerEmailAddress={
                  this.handleBuyerEmailAddressCaptured
                }
                emailAddressTranslations={
                  this.props.tradeInProps.emailCollectionTranslations
                }
                fromTestDriveForm
              />
            </React.Fragment>
          )}
          {this.state.currentStep === "lead_form" && (
            <TestDriveLeadForm
              carInfo={this.state.carAssemblageData.estimation_car}
              leadInfo={this.state.tradeInValuation}
              replacementCar={this.props.replacementCar}
              enableDescriptionOfTheCar={this.props.enableDescriptionOfTheCar}
              enableOwnValuation={this.props.enableOwnValuation}
              extraFields={this.props.extraFields}
              customFields={this.props.customFields}
              translations={this.props.leadFormTranslations}
              bookingSummaryTranslations={
                this.props.testDriveFlowTranslations.completed
              }
              department={this.props.departmentOptions?.filter(
                (d) => d.value === this.state.configKey
              )}
              modelList={this.props.interestedInModelList}
              leadFormUrl={this.state.leadFormUrl}
              carAssemblageData={this.state.carAssemblageData}
              extraLeadQualification={
                this.state.tradeInValuation.extra_lead_qualification
              }
              trackFunction={this.props.trackFunction}
              creationToken={this.state.creationToken}
              tradeInFlowSelectorOptions={this.state.tradeInFlowSelectorOptions}
              configKey={this.state.configKey}
              configParam={this.props.configParam}
              validationTranslations={this.props.validationTranslations}
              maxTradeInValue={this.props.maxTradeInValue}
              bookingTime={this.state.bookingTime}
              vinLpn={this.state.vinLpn}
            />
          )}
        </React.Fragment>
      </CountryProvider>
    )
  }
}

export default TestDriveBookingFlow
